export const _en = {
    addButton: {
        label: "Add skill level"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add skill level"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Niveau de compétence"
    },
    toggleDeleted: {
        label: "Afficher les niveaux archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un niveau de compétence"
        }
    }
};